<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] {{ this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO ||
                                isAdmin ? 'User & Admin' : 'User' }}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="p-grid p-field">
                                    <div class="p-row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Create_Date) }}
                                    </div>
                                    <div class="p-row">
                                        by {{ header.Create_By }}
                                    </div>
                                </div>
                                <div class="p-grid p-field" v-if="header.Edit_Date">
                                    <div class="p-row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edit_Date) }}
                                    </div>
                                    <div class="p-row">
                                        by {{ header.Edit_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)"
                            v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div v-if="header && this.Error_Message && this.submitted">
                        <Message severity="warn" :closable="false">
                            {{ this.Error_Message }}
                        </Message>
                    </div>
                    <TabView>
                        <TabPanel>
                            <template #header>Main Data</template>
                            <div class="grid">
                                <div class="col-6">
                                    <div class="field grid">
                                        <label for="Employee_Number" class="col-4">{{ $t('username') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <!-- <InputText name="Employee_Number" v-model="header.Employee_Number" type="text"
                                                :placeholder="$t('username')"
                                                v-if="header && header.Account != 'USER' && this.$store.getters.getAccount != this.$ACCOUNT.ADMIN_UNIT && this.$store.getters.getAccount != this.$ACCOUNT.USER"
                                                :class="{ 'p-invalid': submitted && !header.Employee_Number }"
                                                :disabled="!canEdit" :readonly="mode != this.$FORM_MODE_CREATE"
                                                v-on:blur="onBlur()" />
                                            <Skeleton v-else-if="!header" /> -->
                                            <CustomSelect class="p-inputtext-sm" v-model="header.Employee_Number"
                                                v-if="header" :filter="true" :url="this.$API_URL + 'list/employee_no'"
                                                :minLength="0" :params="{}" :disabled="mode != this.$FORM_MODE_CREATE"
                                                :class="{ 'p-invalid': submitted && !header.Employee_Number }"
                                                @change="onBlur()" />
                                            <small
                                                v-if="header && !header.Employee_Number && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('username')) }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="field grid">
                                        <label for="Full_Name" class="col-4">{{ $t('full_name') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <InputText name="Full_Name" v-model="header.Full_Name" required="true"
                                                type="text" :placeholder="$t('full_name')" v-if="header"
                                                :class="{ 'p-invalid': submitted && !header.Full_Name }"
                                                :disabled="!canEdit" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Full_Name && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('full_name')) }}
                                            </small>
                                        </div>
                                    </div>

                                    <!-- <FormField :labelName="$t('pic')" fieldName="PIC_Name" v-model="header"
                                        labelClass="col-4" fieldClass="col-8 md-8">
                                        <InputText name="PIC_Name" v-model="header.PIC_Name" type="text"
                                            :placeholder="$t('pic')" v-if="header" :disabled="!canEdit" />
                                    </FormField> -->

                                    <FormField :labelName="$t('email')" fieldName="Email" v-model="header"
                                        labelClass="col-4" fieldClass="col-8 md-8">
                                        <InputText name="Email" v-model="header.Email" type="text"
                                            :placeholder="$t('email')" v-if="header" :disabled="!canEdit" />
                                    </FormField>

                                    <div class="field grid">
                                        <label for="Account" class="col-4">{{ $t('account') }}<span
                                                style="color: red;">*</span></label>
                                        <div class="col-8 md-8">
                                            <CustomSelect class="p-inputtext-sm" v-model="header.Account" v-if="header"
                                                :filter="true" :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                                :disabled="!canEdit || (this.$store.getters.getAccount != this.$ACCOUNT.ADMIN_HO && !isAdmin)"
                                                :readonly="true" :params="{ group: 'ACCOUNT' }"
                                                :class="{ 'p-invalid': submitted && !header.Account }" />
                                            <Skeleton v-else-if="!header" />
                                            <small
                                                v-if="header && !header.Account && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('account')) }}
                                            </small>
                                        </div>
                                    </div>

                                    <FormField :labelName="$t('use_ad')" fieldName="Use_AD" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6">
                                        <ToggleButton v-model="header.Use_AD" onLabel="Yes" offLabel="No"
                                            :style="{ width: '9em' }" v-if="header"
                                            :class="{ 'p-invalid': submitted && !header.Use_AD }" :disabled="true" />
                                    </FormField>

                                    <FormField :labelName="$t('active')" fieldName="Active" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6">
                                        <ToggleButton v-model="header.Active" onLabel="Yes" offLabel="No"
                                            :style="{ width: '9em' }" v-if="header"
                                            :class="{ 'p-invalid': submitted && !header.Active }"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </FormField>
                                    <FormField :labelName="$t('company_all')" fieldName="Company_All" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6" v-if="header"
                                        v-show="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                                        <ToggleButton v-model="header.Company_All" onLabel="Yes" offLabel="No"
                                            :style="{ width: '9em' }"
                                            :class="{ 'p-invalid': submitted && !header.Company_All }"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </FormField>
                                    <FormField :labelName="$t('functional_all')" fieldName="Functional_All" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6" v-if="header"
                                        v-show="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                                        <ToggleButton v-model="header.Functional_All" onLabel="Yes" offLabel="No"
                                            :style="{ width: '9em' }"
                                            :class="{ 'p-invalid': submitted && !header.Functional_All }"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </FormField>
                                    <FormField :labelName="$t('grade_all')" fieldName="Grade_All" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6" v-if="header"
                                        v-show="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                                        <ToggleButton v-model="header.Grade_All" onLabel="Yes" offLabel="No"
                                            :style="{ width: '9em' }"
                                            :class="{ 'p-invalid': submitted && !header.Grade_All }"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </FormField>
                                    <FormField :labelName="$t('unit_all')" fieldName="Unit_All" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6" v-if="header"
                                        v-show="(this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                                        <ToggleButton v-model="header.Unit_All" onLabel="Yes" offLabel="No"
                                            :style="{ width: '9em' }"
                                            :class="{ 'p-invalid': submitted && !header.Unit_All }"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </FormField>
                                    <!-- <FormField :labelName="$t('is_admin')" fieldName="Is_Admin" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6">
                                        <Checkbox v-model="header.Is_Admin" :disabled="!canEdit" v-if="header"
                                            :binary="true" />
                                    </FormField> -->

                                    <FormField v-if="mode != this.$FORM_MODE_CREATE" :labelName="$t('password')"
                                        v-show="header && !header.Use_AD" fieldName="Use_AD" v-model="header"
                                        labelClass="col-4" fieldClass="col-3 md-3">
                                        <Button label="Reset Password" class="p-button-success" :disabled="!canEdit"
                                            v-if="header && !header.Use_AD" @click="confirmResetPass($event)" />
                                        <ConfirmPopup></ConfirmPopup>
                                    </FormField>

                                    <!-- <FormField labelName="Active/Non Active Account" fieldName="Active" v-model="header"
                                        labelClass="col-4" fieldClass="col-6 md-6" v-if="mode == this.$FORM_MODE_EDIT">
                                        <Button label="Active/Non Active" class="p-button-warning" v-if="header"
                                            :disabled="!canEdit" @click="openDialog" />
                                    </FormField> -->

                                </div>
                                <div class="col-6">
                                    <Groups :dataArray="header.Groups" :dataModel="groupModel" :mode="mode" v-if="header"
                                        :header="header" />
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel
                            v-if="header && (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                            <template #header>{{ $t('company') }}<span style="color: red;">*</span></template>
                            <Companies :dataArray="header.Companies" :dataModel="companyModel" v-if="header"
                                :header="header" :mode="mode" />
                        </TabPanel>
                        <TabPanel
                            v-if="header && (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                            <template #header>{{ $t('functional') }}<span style="color: red;">*</span></template>
                            <Functionals :dataArray="header.Functionals" :dataModel="functionalModel" :header="header"
                                :mode="mode" />
                        </TabPanel>
                        <TabPanel
                            v-if="header && (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                            <template #header>{{ $t('grade') }}<span style="color: red;">*</span></template>
                            <Grades :dataArray="header.Grades" :dataModel="gradeModel" :header="header" :mode="mode" />
                        </TabPanel>
                        <!-- <TabPanel :header="$t('role')">
                                <Roles :dataArray="header.Roles" :dataModel="roleModel" v-if="header" :header="header"
                                    :mode="mode" />
                            </TabPanel> -->
                        <TabPanel
                            v-if="header && (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || isAdmin) && this.header.Account != 'USER'">
                            <template #header>{{ $t('unit') }}<span style="color: red;">*</span></template>
                            <Units :dataArray="header.Units" :dataModel="roleModel" :header="header" :mode="mode" />
                        </TabPanel>
                    </TabView>
                </div>
            </template>
        </Card>

        <!-- <ChangePassword
                                                                        v-if="changePassword"
                                                                        :isVisible="changePassword"
                                                                        :userId="username"
                                                                        :requireCurrentPassword="true"
                                                                        @hide="hideChangePasswordDialog"
                                                                    /> -->

        <!-- <Dialog header="Active/Non Active Account" v-model:visible="displayDialog" :closable="false"
                                                                        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '30vw' }">
                                                                        <div>
                                                                            <Message severity="warn" :closable="false">
                                                                                {{ inactive_msg }} ({{ Active ? 'Active' : 'Non Active' }})
                                                                            </Message>
                                                                            <h6 id="single">Please select active or non active account</h6>
                                                                            <SelectButton v-model="Active" :options="activeOption" optionLabel="name" optionValue="value"
                                                                                aria-labelledby="single" />
                                                                        </div>
                                                                        <template #footer>
                                                                            <Button label="Cancel" icon="pi pi-times" @click="closeDialog" class="p-button-text" />
                                                                            <Button label="Save" icon="pi pi-check" @click="saveActiveUser" />
                                                                        </template>
                                                                    </Dialog> -->

    </form>
</template>


<script>
import Companies from './_Companies.vue';
import Functionals from './_Functionals.vue';
import Grades from './_Grades.vue';
import Groups from './_Groups.vue';
import Roles from './_Roles.vue';
import Units from './_Units.vue';

export default {
    name: "Editor",
    components: {
        Companies: Companies,
        Functionals: Functionals,
        Grades: Grades,
        Groups: Groups,
        Roles: Roles,
        Units: Units,
    },
    data() {
        return {
            indexName: "UserIndex",
            url: this.$API_URL + "user/",
            resetPassUrl: this.$API_URL + "user/reset_password",
            isHaveAD: this.$API_URL + "user/is_have_ad",
            stateKey: this.$STATE_NAME + 'user-' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            header: null,
            detail: null,
            mode: "",
            id: 0,
            formEditable: true,
            groupModel: null,
            companyModel: null,
            changePassword: false,
            username: null,
            submitted: false,
            // Active: null,
            // activeOption: [
            //     { name: 'Active', value: true },
            //     { name: 'Non Active', value: false },
            // ],
            displayDialog: false,
            Error_Message: ''
        }
    },
    methods: {
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    if (response.data.success) {
                        self.header = response.data.data.header;
                        self.companyModel = response.data.data.company;
                        self.functionalModel = response.data.data.functional;
                        self.gradeModel = response.data.data.grade;
                        self.groupModel = response.data.data.group;
                        self.roleModel = response.data.data.role;
                        self.unitModel = response.data.data.unit;
                        // self.Active = response.data.data.header.Active;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        saveData() {
            var self = this;
            this.$emit('block-ui');
            this.header.mode = this.mode

            this.$axios.post(this.url, this.header)
                .then((response) => {
                    if (response.data.success) {
                        self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 5000 } });
                    }
                    else {
                        self.$emit('unblock-ui');
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: response.data.message, life: 5000 });
                    }
                })
                .catch(function (error) {
                    self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000 });
                    self.$emit('unblock-ui');
                });
        },
        // saveActiveUser() {
        //     var self = this;
        //     var data = {
        //         "user_id": this.header.Id,
        //         "active": this.Active
        //     };

        //     this.$emit('block-ui');
        //     this.$axios.post(this.$API_URL + "util/user_active_nonactive/", data)
        //         .then((response) => {
        //             self.getData();
        //             self.$emit('unblock-ui');
        //             self.closeDialog();
        //             if (response.data.success) {
        //                 self.$toast.add({ severity: 'success', summary: 'Success Saving Data', detail: "User account has been saved successfully.", life: 50000 });
        //             }
        //             else {
        //                 self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000 });
        //             }
        //         })
        //         .catch(function (error) {
        //             self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000 });
        //             self.$emit('unblock-ui');
        //         });
        // },
        resetPassword() {
            var self = this;
            this.$emit('block-ui');
            this.header.mode = this.mode

            this.$axios.post(this.resetPassUrl, this.header)
                .then((response) => {
                    if (response.data.success) {
                        // self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Password Reset', detail: response.data.message, life: 120000} } );
                        self.$toast.add({ severity: 'success', summary: 'Password Reset', detail: response.data.message, life: 3000 });

                        // self.changePassword = true;
                        // this.username = this.header.Employee_Number;

                        self.$emit('unblock-ui');
                    }
                    else {
                        self.$emit('unblock-ui');
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: response.data.message, life: 3000 });
                    }
                })
                .catch(function (error) {
                    self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 3000 });
                    self.$emit('unblock-ui');
                });
        },
        // hideChangePasswordDialog(event){
        //     self = this;
        //     self.changePassword = false;
        //     // this.errormessage = "";

        //     if(event && event.success){
        //         // this.changePasswordSuccess = event.message;
        //         self.$toast.add({ severity: 'success', summary: 'Password Change', detail: event.message, life: 120000 });
        //     }
        // },
        backToIndex() {
            this.$router.push({ path: "/User/Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;

            if (!this.header.Employee_Number || !this.header.Full_Name || !this.header.Account) {
                return;
            }
            else if (this.header.Groups.length == 0) {
                this.Error_Message = "Group is required";
            }
            else if (this.header.Account == this.$ACCOUNT.ADMIN_UNIT || this.header.Account == this.$ACCOUNT.ADMIN_HO || this.header.Account == this.$ACCOUNT.OU_HEAD) {
                if (!this.header.Company_All && this.header.Companies.length == 0) {
                    this.Error_Message = "Company is required";
                }
                else if (!this.header.Functional_All && this.header.Functionals.length == 0) {
                    this.Error_Message = "Functional is required";
                }
                else if (!this.header.Grade_All && this.header.Grades.length == 0) {
                    this.Error_Message = "Grade is required";
                }
                else if (!this.header.Unit_All && this.header.Units.length == 0) {
                    this.Error_Message = "Unit is required";
                }
                else {
                    this.submitted = false;
                    this.Error_Message = null;
                }
            }
            else {
                this.submitted = false;
                this.Error_Message = null;
            }

            if (!this.submitted) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            }
        },
        confirmResetPass(event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.resetPassword();
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        onBlur() {
            var self = this;
            this.$emit('block-ui');
            this.header.mode = this.mode

            this.$axios.post(this.isHaveAD, this.header)
                .then((response) => {
                    if (response.data.success) {
                        this.header.Full_Name = response.data.data.text;
                        this.header.Email = response.data.data.email;

                        if (response.data.message != "TRUE") {
                            this.header.Use_AD = false;
                        }
                        else {
                            this.header.Use_AD = true;

                            if (this.header.Account == 'USER') {
                                this.header.PIC_Name = response.data.data.text;
                            }
                        }
                    }
                })
                .catch(function (error) {
                    alert(error);
                });

            self.$emit('unblock-ui');
        },
        // openDialog() {
        //     this.inactiveMsg();
        //     this.displayDialog = true;
        // },
        // closeDialog() {
        //     this.displayDialog = false;
        //     this.Active = this.header.Active;
        // },
        // inactiveMsg() {
        //     var userAccount = this.header;
        //     var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
        //     var currentDate = new Date(this.$moment(new Date()).format('L'));

        //     var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
        //     var totalDays = lastDuration / (1000 * 3600 * 24);

        //     if (isNaN(totalDays)) {
        //         this.inactive_msg = "This account has never been active. ";
        //     }
        //     else {
        //         this.inactive_msg = "This account has been inactive for " + totalDays + " days. ";
        //     }
        // }
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;

        this.getData();
    },
    computed: {
        canEdit() {
            return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
        },
        canSave() {
            return this.mode != this.$FORM_MODE_VIEW;
        },
        isOverNotAccess() {
            var duration = 90;
            var userAccount = this.header;
            var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
            var currentDate = new Date(this.$moment(new Date()).format('L'));

            if (userAccount.Last_Access_Date == null) {
                return true;
            }
            else {
                var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
                var totalDays = lastDuration / (1000 * 3600 * 24);

                if (totalDays >= duration) {
                    return true;
                }

                return false;
            }
        }
    }
}
</script>